import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
} from "react-icons/io";
import "./FeaturedProducts.css";

// Images
import banana1 from "./banana1.png";
import banana2 from "./banana2.png";
import banana3 from "./banana3.png";
import tomato from "./tomato.png";
import onion from "./onion.png";
import turmeric from "./turmeric.png";
import cocoa from "./cocoa.png";
import maize from "./maize.png";
import jowar from "./jowar.png";

// Product data with ROUTE PATHS
const products = [
  { name: "Cavendish Banana Powder", img: banana1, path: "/banana-powder" },
  { name: "Mannanra Banana Powder", img: banana2, path: "/banana-powder" },
  { name: "Nendran Banana Powder", img: banana3, path: "/banana-powder" },
  { name: "Tomato Powder", img: tomato, path: "/tomato-powder" },
  { name: "Onion Powder", img: onion, path: "/onion-powder" },
  { name: "Turmeric Powder", img: turmeric, path: "/turmeric-powder" },
  { name: "Cocoa Powder", img: cocoa, path: "/coco-powder" },
   { name: "Jowar", img: jowar, path: "/jowar-powder" },
    { name: "Maize", img: maize, path: "/maize-powder" },
];

export default function FeaturedProducts() {
  const [startIndex, setStartIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(4);
  const navigate = useNavigate();

  // Responsive visible cards
  useEffect(() => {
    const updateVisibleCards = () => {
      if (window.innerWidth <= 480) setVisibleCards(1);
      else if (window.innerWidth <= 768) setVisibleCards(2);
      else if (window.innerWidth <= 1024) setVisibleCards(3);
      else setVisibleCards(4);
    };

    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  const handleNext = () => {
    if (startIndex + visibleCards < products.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  return (
    <div className="featured-container">
      <h2 className="featured-title">Our Featured Products</h2>
      <p className="featured-subtitle">
        Explore our premium-quality fruit and plant powders crafted for
        industrial use across food, cosmetic, and pharmaceutical sectors
      </p>

      <div className="carousel">
        {products
          .slice(startIndex, startIndex + visibleCards)
          .map((product) => (
            <div key={product.name} className="product-card">
              <img
                src={product.img}
                alt={product.name}
                className="product-img"
              />

              <p className="product-name">{product.name}</p>

              {/* ✅ FIXED BUTTON */}
              <button
                type="button"
                className="green-btn"
                onClick={() => navigate(product.path)}
              >
                Show our options
              </button>
            </div>
          ))}
      </div>

      <div className="arrows-container">
        <button
          type="button"
          className="arrow-btn"
          onClick={handlePrev}
          disabled={startIndex === 0}
        >
          <IoIosArrowDropleftCircle />
        </button>

        <button
          type="button"
          className="arrow-btn"
          onClick={handleNext}
          disabled={startIndex + visibleCards >= products.length}
        >
          <IoIosArrowDroprightCircle />
        </button>
      </div>
    </div>
  );
}
